import React, { forwardRef, useRef, useState, useImperativeHandle } from "react";
import { useTranslation } from "src/context/Translations/context";
import { IAction } from "src/pages/Actions/Panel/interface";
import ModalReleaseActionsInDraft from "src/components/ModalReleaseActionsInDraft";
import { IReleaseActionsRef } from "src/components/ModalReleaseActionsInDraft/interface";
import { IPhases, IPrtba004 } from "../Project/Components/Phases/interface";

export interface IProjectReleaseActionsRef{
    openModalReleaseActions: (phase: IPhases, onCallback?: Function) => void;
}

const ModalReleaseActions: React.ForwardRefRenderFunction<IProjectReleaseActionsRef> = (_, ref) => {
	const { translate } = useTranslation();
	const refModalReleaseActions = useRef<IReleaseActionsRef>(null);
    
	// Modal Release Actions
	const [subtitle, setSubtitle] = useState<string | undefined>(undefined);
	const [phaseSelected, setPhaseSelected] = useState<IPhases>();
	const onCallbackRelease = useRef<Function | undefined>(undefined);
	
	const openModalReleaseActions = (phase: IPhases, onCallback?: Function) => {
		setPhaseSelected(phase);
		setSubtitle(`${translate("Fase")}: ${phase.pra003Titulo}`);
		onCallbackRelease.current = onCallback;
		const actions = phase?.prtba004?.filter((p: any) => p.situation === 4).map((phaseAction: IPrtba004) => {
			const action = {} as IAction;
			action.inb001Id = phaseAction.pra004Inb001Id;
			action.inb001Codigo = phaseAction.pra004Inb001Codigo;
			action.inb001Efa005Id = phaseAction.pra004Inb001Efa005Id;
			action.inb001Dtinicio = phaseAction.pra004Inb001DtInicio;
			action.inb001Dtfim = phaseAction.pra004Inb001DtFim;
			action.inb001Efa005Id2 = phaseAction.pra004Inb001Efa005Id2;
			action.inb001Titulo = phaseAction.pra004Inb001Nome;
			return action;
		});

		refModalReleaseActions.current?.openModalReleaseActionsInDraft(actions);
	};

	useImperativeHandle(ref, () => ({
		openModalReleaseActions
	}));

	return (
		<>
			<ModalReleaseActionsInDraft
				ref={refModalReleaseActions}
				onCallbackRelease={onCallbackRelease.current}
				subtitle={subtitle || ""}
				relatedTableId={phaseSelected?.pra003Id || 0}
				relatedMethodController="ProjectPhase/ReleaseActions" />
		</>
	);
};

export default forwardRef(ModalReleaseActions);
